import React, { ComponentType, FC, ReactNode } from 'react';

import getPluginKey from '../helpers/getPluginKey';
import { CommonReferencePickerPlugin } from '../types/ReferencePickerPlugin';

const PluginProvidersProvider: FC<{
  plugins: CommonReferencePickerPlugin[];
  children: ReactNode;
}> = ({ plugins, children }) => {
  return plugins.reduce((content, plugin) => {
    if (plugin?.Provider) {
      const PluginProvider = plugin?.Provider as ComponentType<{
        children: ReactNode;
      }>;
      return (
        <PluginProvider key={getPluginKey(plugin)}>{content}</PluginProvider>
      );
    }
    return content;
  }, children);
};

export default PluginProvidersProvider;
